import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetDepositPromotionResponseData } from '@/modules/promotion/type'
import { columns, writeAccessorKeys } from './constants'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useMemo } from 'react'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableSelector } from '@/common/ui/table/data-table-selector'

interface DepositPromotionTableProps {
	data: GetDepositPromotionResponseData[]
	total: number
	isLoading?: boolean
}

export default function DepositPromotionTable({
	data,
	total,
	isLoading,
}: DepositPromotionTableProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_DEPOSIT_PROMOTION,
	)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSearch placeHolder="ค้นหาโปรโมชั่น" />
				<DataTableResetFilter />
				<DataTableSelector
					options={[
						{ label: 'โปรสำหรับผู้เล่น', value: 'true' },
						{ label: 'โปรสำหรับช่องทาง', value: 'false' },
					]}
					placeholder="เลือกโปรโมชั่น"
				/>
			</div>
			<DataTablePaginate
				columns={filteredColumns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
